<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-05 16:10:44
 * @LastEditors: luckymiaow
 * @LastEditTime: 2022-07-13 09:26:28
-->
<script lang="ts" setup>
import { Divider as ADivider, Popover, message } from 'ant-design-vue';
import { Ellipsis } from '../../ellipsis';
import type { IOpenLink } from '../types';

interface IProps extends IOpenLink {
  href: string;
  maxLength?: number;
}

const props = withDefaults(defineProps<IProps>(), {
  maxLength: 20,
});

function copy() {
  let oInput = document.createElement('input');
  oInput.setAttribute('readonly', 'readonly');
  oInput.setSelectionRange(0, oInput.value.length);
  oInput.value = props.href;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象
  document.execCommand('Copy'); // 执行浏览器复制命令
  oInput.className = 'oInput';
  oInput.style.display = 'none';
  message.success('复制完成');
}

function open() {
  let reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/;
  if (reg.test(props.href)) {
    window.open(props.href);
  } else {
    window.open(`https://${props.href}`);
  }
}
</script>

<template>
  <Popover title="OpenLink" placement="bottom">
    <template #content>
      <a target="_blank" @click="open">跳转</a>
      <a-divider type="vertical" />
      <a @click="copy">复制</a>
    </template>
    <slot>
      <a v-if="props.maxLength" class="file-link"><Ellipsis :value="props.href" :max-length="props.maxLength" /></a>
      <a v-else class="file-link">{{ props.href }}</a>
    </slot>
  </Popover>
</template>
